import React from 'react'

import cardimg from '../ListitemForSaleComponents/auth-left-signup.png'

const ImageCardBox = () => {
    return (
        <div>
            <div className="card">
                <img src={cardimg} className="cardimage" alt="..." />
                <div className="card-body">
                    <div class="container">
                        <div class="row cardrow">
                            <div class="col ">
                            <h6 className='cardtitle'>United Collection : #2134454323</h6>
                    <p className="card-text">Item Name</p>
                            </div>
                            <div class="col textright">
                            <h6 className='cardtitle'>Price</h6>
                    <p className="card-text">0</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default ImageCardBox